import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import {
  ITableColumnCellConfigType,
  ITableColumnConfigType,
  TableActionsColumnType,
  TableColumnAlignType,
  TableColumnType,
} from '../../models';

@Component({
  selector: 'ui-table-base-column',
  template: '',
  standalone: true,
})
export class UITableBaseColumn<T = unknown> {
  @Input() config?: ITableColumnConfigType;
  @Input() data?: NonNullable<T>;
  @Input() index?: number;

  @Output() updateTableData = new EventEmitter<void>();
  @Output() rowClicked = new EventEmitter<TableActionsColumnType>();

  @HostBinding('style.width') get columnWidth() {
    return this.width;
  }
  @HostBinding('style.textAlign') get columnTextAlign() {
    return this.align;
  }

  TableColumnType = TableColumnType;

  get title(): string | undefined {
    return this.config?.title;
  }

  get name(): ITableColumnCellConfigType | string | undefined {
    return this.config?.name;
  }

  get subName(): ITableColumnCellConfigType | string | undefined {
    return this.config?.subName;
  }

  get align(): TableColumnAlignType {
    return this.config?.align ?? 'left';
  }

  get width(): string {
    return this.config?.width ?? 'auto';
  }

  get type(): TableColumnType {
    return this.config?.type == null ? TableColumnType.Basic : this.config.type;
  }

  onUpdateTableData(): void {
    this.updateTableData.emit();
  }
}
